import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useKycUpiVerifyMutation } from "../../redux/kycApi";
import Rejectreason from "./Rejectreason";

function Upi({ kycTrack, refetch }) {
  const [upiId, setUpiId] = useState("");
  const [upiIdError, setUpiIdError] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const [kycUpiVerify] = useKycUpiVerifyMutation();

  const upiIdRegex = /^[\w.-]+@[\w]+$/;
  const status = kycTrack?.progress?.upi_verification?.status;
  const isEditable = status === "pending" || status === "rejected";

  useEffect(() => {
    setUpiId(kycTrack?.progress?.upi_verification?.data?.upi_id || "");
  }, [kycTrack]);

  const handleChange = (e) => {
    const value = e.target.value;
    setUpiId(value);

    if (!value) {
      setUpiIdError("This field is required");
    } else if (value.length > 50) {
      setUpiIdError("UPI ID cannot exceed 50 characters");
    } else if (/\s/.test(value)) {
      setUpiIdError("UPI ID cannot contain spaces");
    } else if (!upiIdRegex.test(value)) {
      setUpiIdError(
        "UPI ID must be in the format username/number@bank/upi domain."
      );
    } else {
      setUpiIdError("");
    }
  };

  const handleSubmit = async () => {
    // 🚨 if any error already set OR empty input → stop
    if (!upiId || upiIdError) {
      if (!upiId) setUpiIdError("This field is required");
      return;
    }

    setBtnDisable(true);
    setTimeout(() => setBtnDisable(false), 3000);

    try {
      const { data, error } = await kycUpiVerify({ upi_id: upiId });
      if (error) {
        toast.error(error?.data?.message || "Something went wrong");
        return;
      }

      if (data?.status) {
        toast.success(data.message || "UPI ID submitted successfully");
        refetch();
      } else {
        toast.error(data?.message || "Failed to submit UPI ID");
      }
    } catch (err) {
      toast.error("Unexpected error occurred");
    }
  };

  return (
    <div className="upi-outer">
      <div className="">
        {/* <div className="col-md-3 col-12"></div> */}
        <div className="">
          <div className="white_box">
            <h6 className="position-relative">UPI Verification </h6>
            <b className="mt-0">Requirements</b>
            <ul className="dit_ul mb-4">
              <li>Please Verify Your UPI Number</li>
            </ul>
            <div className="row">
              <div className="form-group col-lg-4 col-md-6">
                <label>UPI ID</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter UPI ID"
                  name="upi"
                  value={upiId}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
                {upiIdError && <div className="text-danger">{upiIdError}</div>}
                {isEditable && (
                  <div className="save-btn">
                    <button className="btn btn_man mt-3" disabled={btnDisable} onClick={handleSubmit}>
                      {status === "pending" ? "Submit" : "Re-Submit"}
                    </button>
                  </div>
                )}
              </div>
            </div>
            <Rejectreason
              status={kycTrack?.progress?.upi_verification?.status}
              reason={kycTrack?.progress?.upi_verification?.data?.reason}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Upi;
